"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldEditorSubForm = void 0;
const form_palette_1 = require("../form.palette");
const form_field_editor_1 = require("./form.field.editor");
const form_field_tree_view_1 = require("./form.field.tree.view");
const mithril_1 = require("../../../mithril");
const input_select_1 = require("../../../components/input/input.select");
const i18n_1 = require("../../../i18n");
const core_api_1 = require("@ikegps/core-api");
const form_field_editor_subform_span_1 = require("./form.field.editor.subform.span");
class FormFieldEditorSubForm extends form_field_editor_1.FormFieldEditor {
    constructor(designer, field) {
        super(designer, field);
        this.typeEditor = null;
        this.subFormTypeSelectState = this.initialSubFormTypeSelectState();
        // If current type is SPAN, create the span type editor
        if (this.subFormTypeSelectState.value === core_api_1.SubFormType.SPAN) {
            this.typeEditor = new form_field_editor_subform_span_1.SpanSubFormTypeEditor(this.field, this.state);
        }
        // This handler responds to USER changes of the subform type.
        this.subFormTypeSelectState.onValue((subformTypeValue) => {
            var _a, _b;
            if (subformTypeValue === core_api_1.SubFormType.SPAN) {
                this.field.Mutator.span.enable();
                // Destroy any existing editor before creating a new one
                (_a = this.typeEditor) === null || _a === void 0 ? void 0 : _a.destroy();
                this.typeEditor = new form_field_editor_subform_span_1.SpanSubFormTypeEditor(this.field, this.state);
            }
            else {
                (_b = this.typeEditor) === null || _b === void 0 ? void 0 : _b.destroy();
                this.typeEditor = null;
                this.field.Mutator.span.disable();
            }
        });
    }
    initialSubFormTypeSelectState() {
        const options = [];
        if (this.canBeSpan()) {
            options.push({ key: 'Span', value: core_api_1.SubFormType.SPAN });
        }
        const state = new input_select_1.SelectInputState((0, i18n_1.Translate)(i18n_1.T.TYPE), options);
        state.placeholder = (0, i18n_1.Translate)(i18n_1.T.NONE);
        state.setValue(this.field.subFormType);
        this.state.add(state);
        state.isLabelShown = true;
        return state;
    }
    canBeSpan() {
        var _a;
        const spanSubform = (_a = this.designer.form) === null || _a === void 0 ? void 0 : _a.spanSubForm;
        return spanSubform ? spanSubform.id === this.field.id : true;
    }
    viewTree() {
        return form_field_tree_view_1.FormFieldTreeView.viewForm(this);
    }
    viewInfoRW() {
        return (0, mithril_1.m)('div', {}, [
            this.viewSubFormTypeEditor(),
            form_palette_1.FormDesignerPalette.view((type) => this.designer.createField(this.field, type), this.depth),
        ]);
    }
    viewSubFormTypeEditor() {
        if (!this.canBeSpan()) {
            return null;
        }
        return (0, mithril_1.m)('div', { style: { 'margin-bottom': '32px' } }, [
            input_select_1.SelectInputComponent.view(this.subFormTypeSelectState),
            ...(this.typeEditor ? [this.typeEditor.view()] : []),
        ]);
    }
}
exports.FormFieldEditorSubForm = FormFieldEditorSubForm;
//# sourceMappingURL=form.field.editor.subform.js.map